require('./mortgageRequestDocumentationCenter.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const { get, each, find, includes, filter, uniq, isEmpty } = require('lodash');

// @ actions
const documentationCenterActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');

// @ components
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { LoadingSection } = require('commonsComponents/loadingSection');
const MortgageRequestDocumentationCenterHolders = require('components/mortgageRequest/mortgageRequestDocumentationCenter/mortgageRequestDocumentationCenterHolders/mortgageRequestDocumentationCenterHolders');
const MortgageRequestDocumentationCenterLivingPlace = require('./mortgageRequestDocumentationCenterLivingPlace');
const MortgageRequestDocumentationCenterLean = require('./mortgageRequestDocumentationCenterLean');
const MortgageRequestDocumentationMortgagesLoans = require('./mortgageRequestDocumentationCenterMortgagesLoans');
const WebappRender = require('components/conditionalRender/webappRender');

// @ constants
const documentsTypes = require('constants/mortgageRequestDocumentsTypes');
const {
    COHOLDER_ORDER,
    FIRST_BLOCK,
    HOLDER_INTERVENTION_TYPE,
    HOLDER_ORDER,
} = require('constants/mortgageRequestDocumentationCenter');
const mortgageRequestStates = require('constants/mortgageRequestStates');

const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');
const {
    excludeDocumentTypes,
    excludeIRPF100,
    excludeIRPF300,
    holdersCategory,
    leanCategory,
    getDocumentLabel,
    initialValuesLivingPlace
} = require('./initialValues');

class MortgageRequestDocumentationCenter extends React.Component {
    constructor(props) {
        super(props);

        this.dataProprietorStateParseData = [];
        this.summaryDocumentationStateParseData = [];
        this.estatesStateDataParseData = [];
        this.idDocumentType = '';
        this.idDocumentNumber = '';

        this.getFilteredDocumentData = this.getFilteredDocumentData.bind(this);
    }

    componentDidMount() {
        const { mortgageRequestState } = this.props;
        const currentCaseId = mortgageRequestState.get('idExpediente');
        this.props.requestSummaryDocumentation(currentCaseId).then(() => {
            this.props.getDocumentationData();
        })
    }

    getDocumentData(documentsTypeList, idHolderDocumentNumber = '') {
        const documentDataDefault = {
            estado: DOCUMENTS_STATUS.NONE,
            bienId: 0,
            tipoDocumentoId: documentsTypeList[0]
        }
        let documentData;

        for (let i = 0; documentsTypeList[i]; i++) {
            documentData = find(this.summaryDocumentationStateParseData, doc =>
                doc.tipoDocumentoId === documentsTypeList[i] && (!idHolderDocumentNumber || doc.numeroDocumento === idHolderDocumentNumber)
            );
            const documentDataStatus = get(documentData, 'estado', '') || '';

            if (
                documentDataStatus !== DOCUMENTS_STATUS.PEND_APORTAR &&
                documentDataStatus !== ''
            ) { break; }
        }

        return !!documentData ? documentData : documentDataDefault;
    }

    getDocumentsMFH() {
        const documentsMFH = this.summaryDocumentationStateParseData.filter(documentData => {
            const documentType = get(documentData, 'tipoDocumentoId', '');
            const documentStatus = get(documentData, 'estado', '');

            return documentType === documentsTypes.MANIFESTACION_FIRMADA_HIPO &&
                documentStatus !== DOCUMENTS_STATUS.PEND_APORTAR &&
                documentStatus !== DOCUMENTS_STATUS.NONE;
        });

        return documentsMFH.map((documentData, index) => {
            const documentType = get(documentData, 'tipoDocumentoId', '');
            const documentStatus = get(documentData, 'estado', '');
            const documentEstateId = [get(documentData, 'bienId', 0)];
            const idDocumentNumber = get(documentData, 'numeroDocumento', '');
            const idDocumentType = get(documentData, 'tipoDocumento', '');
            const intervenerLabel = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_leanSectionIntervener');
            const labelSufix = documentsMFH.length > 1 ? ` (${intervenerLabel} ${index + 1})` : '';
            const documentTypeLabel = `${getDocumentLabel(documentType)}${labelSufix}`;

            return {
                documentType,
                documentTypeLabel,
                documentStatus,
                documentEstateId,
                idDocumentNumber,
                idDocumentType
            }
        });
    }

    getDocuments(documentsCategory, employmentSituation, idHolderDocumentNumber = '') {
        const { mortgageDataState } = this.props;
        let documentsList = [];

        each(documentsCategory, documentsTypeList => {
            if (documentsTypeList[0] !== documentsTypes.NS) {
                if (documentsTypeList[0] === documentsTypes.MANIFESTACION_FIRMADA_HIPO) {
                    const documentsMFH = this.getDocumentsMFH();
                    documentsList = documentsList.concat(documentsMFH);
                } else {
                    const documentData = this.getDocumentData(documentsTypeList, idHolderDocumentNumber);
                    const documentType = get(documentData, 'tipoDocumentoId', '');
                    const documentTypeLabel = getDocumentLabel(documentType, '', mortgageDataState);
                    const documentStatus = get(documentData, 'estado', '');
                    const documentEstateId = [get(documentData, 'bienId', 0)];
                    if (this.getExcludedDocuments(documentType, documentStatus, employmentSituation)) {
                        documentsList.push({
                            documentType,
                            documentTypeLabel,
                            documentStatus,
                            documentEstateId
                        });
                    }
                }
            } else {
                const documentsNS = this.getDocumentsNS();
                documentsList = documentsList.concat(documentsNS);
            }
        });

        return this.removedDisabledDocuments(documentsList);
    }

    removedDisabledDocuments(documentList) {
        const { flagBasedFeatures } = this.props;
        const flaggedDocuments = [
            { documentType: documentsTypes.PRE_APROB, flag: flagBasedFeatures.get('doc-center-preapproval-letter-enabled') },
            { documentType: documentsTypes.FIPRE, flag: flagBasedFeatures.get('doc-center-fipre-enabled') },
            { documentType: documentsTypes.FIAE, flag: flagBasedFeatures.get('doc-center-fiae-enabled') },
            { documentType: documentsTypes.INF_GASTOS_HIPO, flag: flagBasedFeatures.get('doc-center-info-mortgages-expenses-enabled') },
            { documentType: documentsTypes.INF_CUOTAS_HIPO, flag: flagBasedFeatures.get('doc-center-info-mortgages-dues-enabled') },
            { documentType: documentsTypes.FEIN, flag: flagBasedFeatures.get('doc-center-fein-enabled') },
            { documentType: documentsTypes.ADVERTENCIA_HIPO, flag: flagBasedFeatures.get('doc-center-advertise-mandatory-enabled') },
            { documentType: documentsTypes.MORTGAGE_WRITING_LETTER, flag: flagBasedFeatures.get('doc-center-project-contract-enabled') },
            { documentType: documentsTypes.INSURANCE_PRE_POLICY, flag: flagBasedFeatures.get('doc-center-insurances-warranty-enabled') },
            { documentType: documentsTypes.MANIFESTACION_FIRMADA_HIPO, flag: flagBasedFeatures.get('doc-center-signed-manifest-enabled') },
            { documentType: documentsTypes.NUEVA_LEY_DOC_1, flag: flagBasedFeatures.get('doc-center-new-law-doc1-enabled') },
            { documentType: documentsTypes.NUEVA_LEY_DOC_2, flag: flagBasedFeatures.get('doc-center-new-law-doc2-enabled') }
        ];

        const disabledDocuments = flaggedDocuments.filter(item => (
            !item.flag
        ));

        return documentList.map(item => {
            if (disabledDocuments.filter(itemF => itemF.documentType === item.documentType).length === 0) {
                return item;
            }
        });

    }

    getDocumentsHolderLoans(employmentSituation, idHolderDocumentNumber = '') {
        let documentsList = [];

        filter(this.summaryDocumentationStateParseData, item => {
            const documentTypeId = item.tipoDocumentoId === documentsTypes.RECIB_HIPO || item.tipoDocumentoId === documentsTypes.RECIB_PREST;
            const holderId = idHolderDocumentNumber === item.numeroDocumento;

            if (holderId && documentTypeId) {
                const documentId = [item.tipoDocumentoId];
                const documentData = this.getDocumentData(documentId, idHolderDocumentNumber);
                const documentType = item.tipoDocumentoId
                const documentTypeLabel = getDocumentLabel(documentType);
                const documentStatus = item.estado;
                const documentEstateId = [get(documentData, 'bienId', 0)];
                const documentLoanId = item.idPrestamo;

                if (this.getExcludedDocuments(documentType, documentStatus, employmentSituation)) {
                    documentsList.push({
                        documentType,
                        documentTypeLabel,
                        documentStatus,
                        documentEstateId,
                        documentLoanId
                    });
                }
            }
        });

        return documentsList;
    }

    getDocumentsNS() {
        const documentsNS = {};
        const livingPlaces = initialValuesLivingPlace();
        each(livingPlaces, (doc, NSType) => {

            if (doc.documentType === documentsTypes.NS) {
                const idListType = get(this.estatesStateDataParseData, NSType.replace('NS_', ''), []);

                const documentsFilterBienIds = idListType.map(id => {
                    const items = [];
                    if (!isEmpty(this.summaryDocumentationStateParseData)) {
                        const itemsNS = filter(this.summaryDocumentationStateParseData, item => {
                            return item.bienId === id && (item.tipoDocumentoId === documentsTypes.NS || item.tipoDocumentoId === documentsTypes.NS_CLI)
                        });
                        each(itemsNS, item => {
                            items.push(item.bienId);

                            if (item.estado === DOCUMENTS_STATUS.PEND_VAL || item.estado === DOCUMENTS_STATUS.VERIFICADO || item.estado === DOCUMENTS_STATUS.NO_VALIDO) {
                                doc.documentStatus = item.estado;
                                doc.documentType = item.tipoDocumentoId;
                            }
                        });

                    }
                    return uniq(items);
                });

                const documentsFiltered = [];

                each(documentsFilterBienIds, document => documentsFiltered.push(get(document, '0', [])));
                doc.documentEstateId = documentsFiltered;
            } else {
                const itemsNS = filter(this.summaryDocumentationStateParseData, item => {
                    return item.tipoDocumentoId === NSType || item.tipoDocumentoId === `${NSType}_CLI`
                });

                each(itemsNS, item => {
                    if (item.estado === DOCUMENTS_STATUS.PEND_VAL || item.estado === DOCUMENTS_STATUS.VERIFICADO || item.estado === DOCUMENTS_STATUS.NO_VALIDO) {
                        doc.documentStatus = item.estado;
                        doc.documentType = item.tipoDocumentoId;
                        doc.documentEstateId = item.bienId;
                    }
                });

            }
            documentsNS[NSType] = doc;
        });

        return documentsNS;
    }

    getExcludedDocuments(documentType, documentStatus, employmentSituation) {
        return (
            !(
                (documentType === documentsTypes.IRPF100 || documentType === documentsTypes.IRPF100_CLI) &&
                !includes(excludeIRPF100, employmentSituation)
            ) &&
            !(
                documentType === documentsTypes.IRPF130 &&
                !includes(excludeIRPF300, employmentSituation)
            ) &&
            !(
                documentStatus === DOCUMENTS_STATUS.EXENTO
            ) &&
            !(
                includes(excludeDocumentTypes, documentType) &&
                (
                    documentStatus === DOCUMENTS_STATUS.PEND_APORTAR ||
                    documentStatus === DOCUMENTS_STATUS.NONE
                )
            )
        );
    }

    getHoldersList(fromLoans) {
        const holdersList = [];

        each(this.dataProprietorStateParseData, holder => {
            const idDocumentNumber = get(holder, 'datosPersonales.documentoDeIdentidad.identificador', '');
            const laboralSituation = get(holder, 'datosEmpleo.situacionLaboral', '');

            let documentsData;

            if (fromLoans) {
                documentsData = this.getDocumentsHolderLoans(laboralSituation, idDocumentNumber);
            } else {
                documentsData = this.getDocuments(holdersCategory, laboralSituation, idDocumentNumber);
            }

            holdersList.push({
                idHolder: get(holder, 'numeroTitular', 0),
                idDocumentType: get(holder, 'datosPersonales.documentoDeIdentidad.tipoDocumentoIdentidad', ''),
                idDocumentNumber: idDocumentNumber,
                documents: documentsData
            })
        });

        return holdersList;
    }

    getLeanList() {
        return {
            idDocumentType: this.idDocumentType,
            idDocumentNumber: this.idDocumentNumber,
            documents: this.getDocuments(leanCategory)
        };
    }

    getLivingPlaceList() {
        return {
            idDocumentType: this.idDocumentType,
            idDocumentNumber: this.idDocumentNumber,
            documents: this.getDocumentsNS()
        };
    }

    getFilteredDocumentData() {
        const { summaryDocumentationState, immProfile, mortgageRequestState } = this.props;
        const userDocumentNumber = immProfile.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
        const isCoHolderAvailable = mortgageRequestState.get('estado') !== mortgageRequestStates.CONFIRMA_DATOS_T2;

        const coHolderIsLoggedIn = summaryDocumentationState.get('data').some((immDocumentData) => {
            const orderNm = immDocumentData.get('orderNm');
            const idDocumentNumber = immDocumentData.get('numeroDocumento');

            return orderNm === COHOLDER_ORDER && userDocumentNumber === idDocumentNumber;
        });

        return summaryDocumentationState.get('data').reduce((holderData, immDocumentData) => {
            const documentInterventionType = immDocumentData.get('interventionType');
            const position = immDocumentData.get('position');
            const idDocumentType = immDocumentData.get('tipoDocumento');
            const idDocumentNumber = immDocumentData.get('numeroDocumento');
            const orderNm = immDocumentData.get('orderNm');
            const isFirstBlock = position === FIRST_BLOCK;
            const isValidIntervention = documentInterventionType === HOLDER_INTERVENTION_TYPE;
            const isDocumentForHolder = orderNm === HOLDER_ORDER && userDocumentNumber === idDocumentNumber;
            const isDocumentForCoHolder = orderNm === COHOLDER_ORDER && (!coHolderIsLoggedIn || userDocumentNumber === idDocumentNumber);

            if (idDocumentType && idDocumentNumber && isFirstBlock && isValidIntervention && (isDocumentForHolder || (isDocumentForCoHolder && isCoHolderAvailable))) {
                const documentId = immDocumentData.get('documentoId');
                const documentType = immDocumentData.get('tipoDocumentoId');
                const documentLabel = immDocumentData.get('tipoHipoteca');
                const documentState = immDocumentData.get('estado');
                const mortgageOtherDocumentId = immDocumentData.get('mortgageOtherDocumentId');
                const currentElement = {
                    idDocumentType,
                    idDocumentNumber,
                    documentId,
                    documentType,
                    documentLabel,
                    documentState,
                    mortgageOtherDocumentId,
                    orderNm
                };

                if (holderData.length > 0) {
                    const indexIsSameTypeDocument = holderData.findIndex(element =>
                        element.length === 1 &&
                        element[0].documentType === documentType &&
                        element[0].documentLabel === documentLabel &&
                        element[0].orderNm !== orderNm
                    );

                    if (indexIsSameTypeDocument >= 0) {
                        holderData[indexIsSameTypeDocument].push(currentElement);

                        return holderData;
                    }
                }

                holderData.push([currentElement]);
            }

            return holderData;
        }, []);
    }

    configRenderData(dataProprietorState, estatesStateData, summaryDocumentationState) {
        const dataProprietorStateParse = dataProprietorState.toJS();
        const summaryDocumentationStateParse = summaryDocumentationState.toJS();
        const estatesStateDataParse = estatesStateData.toJS();

        this.dataProprietorStateParseData = get(dataProprietorStateParse, 'data', []);
        this.summaryDocumentationStateParseData = get(summaryDocumentationStateParse, 'data', []);
        this.estatesStateDataParseData = get(estatesStateDataParse, 'dataPanel', []);

        this.idDocumentType = get(this.dataProprietorStateParseData[0], 'datosPersonales.documentoDeIdentidad.tipoDocumentoIdentidad', '');
        this.idDocumentNumber = get(this.dataProprietorStateParseData[0], 'datosPersonales.documentoDeIdentidad.identificador', '');

        return {
            holdersList: this.getFilteredDocumentData(),
            holderListLoans: this.getHoldersList(true),
            livingPlaceList: this.getLivingPlaceList(),
            leanList: this.getLeanList()
        }
    }

    render() {
        const {
            dataProprietorState,
            estatesStateData,
            summaryDocumentationState,
            mortgageDataState,
            immMortgageRequestDocumentationCenter,
            uploadFile,
            getDocument
        } = this.props;
        const isAllRequested = dataProprietorState.get('hasBeenFetched') &&
            summaryDocumentationState.get('documentsRequested') &&
            estatesStateData.get('dataPanelRequested') &&
            mortgageDataState.get('req');

        if (!isAllRequested) {
            return <LoadingSection />;
        }

        const data = this.configRenderData(
            dataProprietorState,
            estatesStateData,
            summaryDocumentationState
        );

        return (
            <div className="mortgage-request-documentation-center">
                <div className="row">
                    <div className="col-md-9-cc-12">
                        <MortgageRequestDocumentationCenterHolders
                            immMortgageRequestDocumentationCenter={immMortgageRequestDocumentationCenter}
                            holders={data.holdersList}
                            uploadFile={uploadFile}
                            getDocument={getDocument}
                        />
                        <MortgageRequestDocumentationCenterLivingPlace
                            livingPlace={data.livingPlaceList}
                        />
                        <MortgageRequestDocumentationMortgagesLoans
                            holders={data.holderListLoans}
                        />
                        <MortgageRequestDocumentationCenterLean
                            lean={data.leanList}
                        />
                    </div>
                    <WebappRender>
                        <div className="col-md-3 mortgage-request-documentation-center__add">
                            <CommercialAds path="documentation" type="banner-b" />
                        </div>
                    </WebappRender>
                </div>
            </div>
        );
    }
}

MortgageRequestDocumentationCenter.propTypes = {
    dataProprietorState: PropTypes.object,
    estatesStateData: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
    getDocument: PropTypes.func,
    getDocumentationData: PropTypes.func,
    immMortgageRequestDocumentationCenter: PropTypes.object,
    immProfile: PropTypes.object,
    mortgageDataState: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    path: PropTypes.string,
    requestMortgageData: PropTypes.func,
    summaryDocumentationState: PropTypes.object,
    uploadFile: PropTypes.func,
    requestSummaryDocumentation: PropTypes.func,
}

module.exports.constructor = MortgageRequestDocumentationCenter;

module.exports.MortgageRequestDocumentationCenter = connect(state => ({
    dataProprietorState: state.mortgageRequestDataProprietor,
    estatesStateData: state.mortgageRequestEstatesData,
    flagBasedFeatures: state.flagBasedFeatures,
    immMortgageRequestDocumentationCenter: state.mortgageRequestDocumentationCenter,
    immProfile: state.profile,
    mortgageDataState: state.mortgageRequestMortgageData,
    mortgageRequestState: state.mortgageRequestState,
    summaryDocumentationState: state.mortgageRequestSummaryDocumentation,
}), {
    getDocumentationData: documentationCenterActions.getDocumentationData,
    uploadFile: documentationCenterActions.uploadFile,
    getDocument: documentationCenterActions.getDocument,
    requestSummaryDocumentation: dataProprietorActions.requestSummaryDocumentation,
})(MortgageRequestDocumentationCenter);
